import * as ActionTypes from '../action-types'

const loyalty_defaultState = {
    byID: {},
    allIDs: [],
}

export const loyalty = (state = loyalty_defaultState, action) => {

    let newState = JSON.parse(JSON.stringify(state))

    if(!action) return newState

    switch (action.type) {
        case ActionTypes.LOYALTY_GET_ALL: {

            const loyalties = action.loyalties

            loyalties
            &&
            loyalties.length
            &&
            loyalties.map(loyalty => {

                const { ltyid } = loyalty

                newState.byID[ltyid] = loyalty

                if(!newState.allIDs.includes(ltyid)) newState.allIDs.push(ltyid)

                return null
            })

            return newState;
        }
        default: {
            return state;
        }
    }
}
